// extracted by mini-css-extract-plugin
export var subtitle = "FlybusSchedule-module--subtitle--2nwT6";